import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import styled from 'styled-components'

import review1PC from '@/assets/images/main-sec4-reveiw1.png'
import review1Mobile from '@/assets/images/main-sec4-reveiw1-mobile.png'
import review2PC from '@/assets/images/main-sec4-reveiw2.png'
import review2Mobile from '@/assets/images/main-sec4-reveiw2-mobile.png'
import review3PC from '@/assets/images/main-sec4-reveiw3.png'
import review3Mobile from '@/assets/images/main-sec4-reveiw3-mobile.png'
import review4PC from '@/assets/images/main-sec4-reveiw4.png'
import review4Mobile from '@/assets/images/main-sec4-reveiw4-mobile.png'
import useMediaQuery from '@/shared/hooks/useMediaQuery'
import { Nanum_rb_size } from '@/styles/font/NanumSquare'
import { mediaTablet } from '@/styles/mediaQuery'
import { icoSet } from '@/styles/mixins'

const rewardImages = [
  {
    pc: review1PC,
    mobile: review1Mobile,
    alt: '리뷰 이미지 1',
  },
  {
    pc: review2PC,
    mobile: review2Mobile,
    alt: '리뷰 이미지 2',
  },
  {
    pc: review3PC,
    mobile: review3Mobile,
    alt: '리뷰 이미지 3',
  },
  {
    pc: review4PC,
    mobile: review4Mobile,
    alt: '리뷰 이미지 4',
  },
]

const AwradReviewList = () => {
  const { isMobile } = useMediaQuery()

  const reviewRef = useRef(null)
  const reviewInView = useInView(reviewRef, { once: true })

  const fadeVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  }

  return (
    <ReviewList ref={reviewRef}>
      <ReviewTitle>구글 스토어 리뷰</ReviewTitle>
      {rewardImages.map((img, idx) => (
        <ReviewItem
          key={idx}
          variants={fadeVariants}
          initial="hidden"
          animate={reviewInView ? 'visible' : 'hidden'}
          transition={{
            delay: idx * 0.3,
            duration: 0.3,
            ease: 'easeOut',
          }}
        >
          <img src={isMobile ? img.mobile : img.pc} alt={img.alt} />
        </ReviewItem>
      ))}
      <Dots />
    </ReviewList>
  )
}
export default AwradReviewList

const ReviewList = styled.ul`
  display: flex;
  flex-direction: column;
`

const ReviewTitle = styled.h4`
  display: none;

  ${mediaTablet} {
    display: block;
    margin-bottom: 12px;
    ${Nanum_rb_size(24)}
  }
`
const ReviewItem = styled(motion.li)`
  margin: 0 auto;

  img {
    ${icoSet}
    width: 766px;
    height: 122px;
  }

  ${mediaTablet} {
    img {
      width: 336px;
      height: 110px;
    }
  }
`

const Dots = () => (
  <DotsList>
    {Array.from({ length: 3 }, (_, i) => (
      <Dot key={i} />
    ))}
  </DotsList>
)

const DotsList = styled.ul`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
  margin-top: 12px;
`

const Dot = styled.li`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--gray-78);

  ${mediaTablet} {
    width: 6px;
    height: 6px;
  }
`
